import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { Button, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddNewCategoryHT from "./AddNewCategoryHT";
import { useState } from "react";
import CreateCategoryModal from "./CreateCategoryModal";

const MainTemplateModal = (props) => {
  const { createNewSite, HandleCreateSite, AllCategoryList, innerTemplate, actions, title, type, currentTemplateId, onModalClose, LoadList,templateDetails, updateTemplate, requestUpdate } = props;
  const companyKey = sessionStorage.getItem("company-key") || "";
  const isNewCategory = type === "newcat";
  const [openCreateCategoryModal, setOpenCreateCategoryModal] = useState(false);
  return (
    <Modal
      open={createNewSite}
      onClose={() => HandleCreateSite()}
      className="edit-category-outer-modal"
    >
      <Box sx={{ maxWidth: type === "summary" ? "945px" : "730px" }} className="edit-category-modal">

        {/* ------------------ CONDITION: SHOW NEW CATEGORY COMPONENT ------------------ */}
        {isNewCategory ? (
          <>
            <AddNewCategoryHT
              actions={actions}
              LoadList={LoadList}
              companyKey={companyKey}
              onModalClose={onModalClose}
              createNewSite={createNewSite}
              AllCategoryList={AllCategoryList}
              HandleCreateSite={HandleCreateSite}
              currentTemplateId={currentTemplateId}
              templateDetails={templateDetails}
              updateTemplate={updateTemplate}
              requestUpdate={requestUpdate}
            />
            <CreateCategoryModal
              open={openCreateCategoryModal}
              onClose={() => setOpenCreateCategoryModal(false)}
            // onSave={(name) => handleCreateCategory(name)}
            />
          </>
        ) : (
          /* ------------------ DEFAULT MODAL LAYOUT ------------------ */
          <Grid className="inspection-filter-modal-grid-main" container spacing={2}>
            <Grid item xs={11.5}>
              <h3 className="modal_title">{title}</h3>

              {type === "newcat" ? (
                <div className="modal_desc">
                  Choose one or more categories from the list below. If a category exists in this template, another instance will be added. Choose "Blank Category" to add an empty category with your content.
                </div>
              ) : type === "summary" ? (
                <div className="modal_desc">
                  This disclaimer will appear in the summary section of the Interactive Report and the PDF report.
                </div>
              ) : null}
            </Grid>

            <Grid item xs={0.5}>
              <CloseIcon
                onClick={() => HandleCreateSite()}
                className="inspection-filter-modal-close-icon"
              />
            </Grid>

            {innerTemplate}

            <Grid container spacing={2} className="inspection-filter-modal-buttons">
              <Button
                className="inspection-filter-modal-buttons-cancel"
                onClick={() => HandleCreateSite()}
              >
                Cancel
              </Button>

              <Button
                className="inspection-filter-modal-buttons-apply"
                onClick={() => actions?.AddSiteDetaill?.()}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        )}
      </Box>
    </Modal>
  );
};

export default MainTemplateModal;